import { store } from "common/store";

export const getCurrencyDecimals = function(currency) {
    return store.getState().common.mappings.currencies[currency]?.decimals ?? 2;
};

export const getCurrencySymbol = function(currency) {
    return store.getState().common.mappings.currencies[currency]?.symbol || "";
};

export const getCurrencyName = function(currency) {
    return store.getState().common.mappings.currencies[currency]?.name || currency;
};
